/**
 * @file RegulationHint.tsx
 * @description Пояснение под полем «Регламент маркировки» вида товара
 * (замечание пользователя 2026-09-26: «что такое Регламент — непонятно»).
 *
 * Текст — по выбранному значению из реестра `REGULATION_HINTS`, ниже общая
 * строка «зачем это системе» и ссылка на официальный текст на сайте ЕЭК.
 * `id` связывает подсказку с полем через `aria-describedby`.
 */

import { ExternalLink, Info } from "lucide-react";

import type { LabelingRegulation } from "../../../lib/api-product-kinds";
import { REGULATION_COMMON_HINT, REGULATION_HINTS } from "../../../lib/product-kind-format";

interface Props {
  id: string;
  value: LabelingRegulation;
}

export function RegulationHint({ id, value }: Props) {
  const hint = REGULATION_HINTS[value];
  return (
    <div id={id} className="flex flex-col gap-1 text-xs text-on-surface-variant">
      <p className="flex items-start gap-1.5 text-on-surface">
        <Info className="mt-0.5 size-3.5 shrink-0 text-primary" aria-hidden />
        <span>{hint.text}</span>
      </p>
      <p>{REGULATION_COMMON_HINT}</p>
      {hint.url ? (
        <a
          href={hint.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-12 items-center gap-1 self-start text-primary underline-offset-4 hover:underline sm:min-h-0"
        >
          Текст регламента
          <ExternalLink className="size-3.5" aria-hidden />
        </a>
      ) : null}
    </div>
  );
}
